import React, { Component } from 'react';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import { personalInformation } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import { FORM_KEYS } from 'shared/constant';
import arrOptions from 'shared/constant/arrOptions';
import {
  PaddedContainer,
  Input,
  Label,
  SimpleSelectBox,
  FormElementContainer,
  Notes,
  Options,
  CheckMark,
  DateInput,
  Textarea,
  SelectBox,
  CountryCodeDropdown,
} from 'components';
import validation from 'shared/validations';
import utils from 'shared/helpers/utils';

class AuthorizedSignatoryInformation extends Component {
  state = {
    countryCode: 'KW',
  };

  onElementChange = (e) => {
    const { onUpdateASI } = this.props;

    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    /** clear fields on isPOAholder if on legal guardian screen (vice versa) */
    if (fieldName === 'authorityToDeal') onUpdateASI('isPOAholder', '');
    if (fieldName === 'isPOAholder') onUpdateASI('authorityToDeal', '');

    onUpdateASI(fieldName, fieldValue);
  };

  onDateChange = (name, value) => {
    if (name && value) this.props.onUpdateASI(name, value);
  };

  onHandleSelect = (name, value) => {
    if (name && value) this.props.onUpdateASI(name, value);
  };

  onPoaChange = ({ target }) => {
    const { onUpdateIsPoa } = this.props;
    const { id } = target;
    const { getStringAfterSpecialChar } = utils;
    const selected = getStringAfterSpecialChar(id, '_');
    onUpdateIsPoa(selected);
    this.props.onUpdateASI('authorityToDeal', '');
  };

  onHandleCountryChange = (name, country) => {
    console.log(country);
    this.props.onUpdateASI(name, country);
  };

  render() {
    const {
      intl,
      isPOAholder,
      poaName,
      poaAddress,
      poaEmailAddress,
      poaNationality,
      poaDateOfBirth,
      poaOccupation,
      poaPosition,
      poaMobile,
      poaEmployerBusinessName,
      poaRelationshipWithClient,
      poaIsAsUSPerson,
      userAge,
      userDOB,
      isAuthorityToDeal,
      isSubmitClicked,
      poaMobileCC,
      poaHomeNumber,
      poaHomeNumberCC,
      formOptions,
    } = this.props;
    const { ASI } = FORM_KEYS;
    const { nationalities, defaultBoolOptions, occupationNA } = arrOptions;
    const { occupation: occupations } = formOptions;

    const elementValidation = {
      [ASI.IS_AUTHORITY_TO_DEAL]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.IS_AUTHORITY_TO_DEAL,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ authorityToDeal: isAuthorityToDeal }),
        errorMessage: validation.getErrorMessages(
          { authorityToDeal: isAuthorityToDeal },
          validation.asiFieldsSchema(
            intl,
            ASI.IS_AUTHORITY_TO_DEAL,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.POA_HOLDER]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.POA_HOLDER,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ isPOAholder }),
        errorMessage: validation.getErrorMessages(
          { isPOAholder },
          validation.asiFieldsSchema(
            intl,
            ASI.POA_HOLDER,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.NAME]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.NAME,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaName }),
        errorMessage: validation.getErrorMessages(
          { poaName },
          validation.asiFieldsSchema(
            intl,
            ASI.NAME,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.ADDRESS]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.ADDRESS,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaAddress }),
        errorMessage: validation.getErrorMessages(
          { poaAddress },
          validation.asiFieldsSchema(
            intl,
            ASI.ADDRESS,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.EMAIL_ADDRESS]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.EMAIL_ADDRESS,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaEmailAddress }),
        errorMessage: validation.getErrorMessages(
          { poaEmailAddress },
          validation.asiFieldsSchema(
            intl,
            ASI.EMAIL_ADDRESS,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.DOB]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.DOB,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaDateOfBirth }),
        errorMessage: validation.getErrorMessages(
          { poaDateOfBirth },
          validation.asiFieldsSchema(
            intl,
            ASI.DOB,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.NATIONALITY]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.NATIONALITY,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaNationality }),
        errorMessage: validation.getErrorMessages(
          { poaNationality },
          validation.asiFieldsSchema(
            intl,
            ASI.NATIONALITY,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.OCCUPATION]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.OCCUPATION,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaOccupation }),
        errorMessage: validation.getErrorMessages(
          { poaOccupation },
          validation.asiFieldsSchema(
            intl,
            ASI.OCCUPATION,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.POSITION]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.POSITION,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaPosition }),
        errorMessage: validation.getErrorMessages(
          { poaPosition },
          validation.asiFieldsSchema(
            intl,
            ASI.POSITION,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.MOBILE]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.MOBILE,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaMobile }),
        errorMessage: validation.getErrorMessages(
          { poaMobile },
          validation.asiFieldsSchema(
            intl,
            ASI.MOBILE,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.EMPLOYER_BUSINESS_NAME]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.EMPLOYER_BUSINESS_NAME,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaEmployerBusinessName }),
        errorMessage: validation.getErrorMessages(
          { poaEmployerBusinessName },
          validation.asiFieldsSchema(
            intl,
            ASI.EMPLOYER_BUSINESS_NAME,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.RELATIONSHIP_WITH_CLIENT]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.RELATIONSHIP_WITH_CLIENT,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaRelationshipWithClient }),
        errorMessage: validation.getErrorMessages(
          { poaRelationshipWithClient },
          validation.asiFieldsSchema(
            intl,
            ASI.RELATIONSHIP_WITH_CLIENT,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
      [ASI.IS_AS_US_PERSON]: {
        isValid: validation
          .asiFieldsSchema(
            intl,
            ASI.IS_AS_US_PERSON,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          )
          .isValidSync({ poaIsAsUSPerson }),
        errorMessage: validation.getErrorMessages(
          { poaIsAsUSPerson },
          validation.asiFieldsSchema(
            intl,
            ASI.IS_AS_US_PERSON,
            userAge,
            isPOAholder,
            isAuthorityToDeal,
            poaOccupation,
          ),
        ),
      },
    };

    const { translateAnswer } = utils;

    return (
      <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
        {userDOB && userAge < 21 ? (
          <FormElementContainer>
            <Label label={intl.formatMessage({ id: 'asi.authorityToDeal' })} />
            <CheckMark
              type="radio"
              label={intl.formatMessage({ id: 'asi.legalGuardian' })}
              id="legalGuardian"
              name={ASI.IS_AUTHORITY_TO_DEAL}
              defaultValue={isAuthorityToDeal}
              hasContainer
              isDisabled
              onCheckMarkChange={this.onElementChange}
            />

            {!elementValidation[ASI.IS_AUTHORITY_TO_DEAL].isValid && (
              <span
                className="notification notification--error"
                style={{ marginTop: '5px' }}
              >
                {elementValidation[ASI.IS_AUTHORITY_TO_DEAL].errorMessage}
              </span>
            )}
          </FormElementContainer>
        ) : (
          <FormElementContainer>
            <Label label={intl.formatMessage({ id: 'asi.poa' })} />
            <Options
              isMultpleElements
              type="radio"
              hasContainer
              useLabel
              name={ASI.POA_HOLDER}
              optionList={defaultBoolOptions.map(item => ({
                id: `isPoa_${item.id}`,
                label: item.label,
              }))}
              onCheckMarkChange={this.onPoaChange}
              defaultValue={translateAnswer(isPOAholder, intl)}
              isValid={elementValidation[ASI.POA_HOLDER].isValid}
              errorMessage={elementValidation[ASI.POA_HOLDER].errorMessage}
              isSubmitClicked={isSubmitClicked}
              // isDisabled
            />
          </FormElementContainer>
        )}

        <Notes
          msg={(
            <div>
              <p>
                <FormattedHTMLMessage id="info.authorizedSignatory.desc1" />
              </p>
              <p>
                <FormattedHTMLMessage id="info.authorizedSignatory.desc2" />
              </p>
            </div>
          )}
        />

        {(translateAnswer(isPOAholder, intl)
          === intl.formatMessage({ id: 'yes' })
          || isPOAholder === 'isPoa-yes'
          || isAuthorityToDeal
            === intl.formatMessage({ id: 'asi.legalGuardian' })
          || isAuthorityToDeal === 'legalGuardian') && (
          <>
            <p>{intl.formatMessage({ id: 'asi.pleaseComplete' })}</p>

            <FormElementContainer>
              <Input
                label={intl.formatMessage({ id: 'asi.name' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.name' }).toLowerCase()}`}
                name={ASI.NAME}
                onInputChange={this.onElementChange}
                value={poaName}
                isValid={elementValidation[ASI.NAME].isValid}
                errorMessage={elementValidation[ASI.NAME].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />

              <Textarea
                label={intl.formatMessage({ id: 'asi.address' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.address' }).toLowerCase()}`}
                name={ASI.ADDRESS}
                onInputChange={this.onElementChange}
                value={poaAddress}
                isValid={elementValidation[ASI.ADDRESS].isValid}
                errorMessage={elementValidation[ASI.ADDRESS].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />

              <Input
                type="email"
                label={intl.formatMessage({ id: 'asi.email' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.email' }).toLowerCase()}`}
                name={ASI.EMAIL_ADDRESS}
                onInputChange={this.onElementChange}
                value={poaEmailAddress}
                isValid={elementValidation[ASI.EMAIL_ADDRESS].isValid}
                errorMessage={elementValidation[ASI.EMAIL_ADDRESS].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />

              <SimpleSelectBox
                label={intl.formatMessage({ id: 'asi.nationality' })}
                placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'asi.nationality' })}`}
                dataList={nationalities}
                name={ASI.NATIONALITY}
                onSelect={this.onHandleSelect}
                defaultValue={poaNationality}
                isSearchInputDisabled={false}
                isValid={elementValidation[ASI.NATIONALITY].isValid}
                errorMessage={elementValidation[ASI.NATIONALITY].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />

              {/* <Input
                label={intl.formatMessage({ id: 'asi.dob' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.dob' }).toLowerCase()}`}
                name={ASI.DOB}
                onInputChange={this.onElementChange}
                value={dob}
              /> */}

              <DateInput
                label={intl.formatMessage({ id: 'asi.dob' })}
                name={ASI.DOB}
                onInputChange={this.onDateChange}
                value={poaDateOfBirth}
                isValid={elementValidation[ASI.DOB].isValid}
                errorMessage={elementValidation[ASI.DOB].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />

              <SelectBox
                label={intl.formatMessage({ id: 'asi.occupation' })}
                placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'asi.occupation' })}`}
                dataList={occupations.filter(
                  item => item.id !== 'NW-MAR-OCC-MN',
                )} // exclude minor
                name={ASI.OCCUPATION}
                onSelect={this.onHandleSelect}
                defaultValue={poaOccupation}
                isSearchInputDisabled
                isValid={elementValidation[ASI.OCCUPATION].isValid}
                errorMessage={elementValidation[ASI.OCCUPATION].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />

              <Input
                label={intl.formatMessage({ id: 'asi.position' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.position' }).toLowerCase()}`}
                name={ASI.POSITION}
                onInputChange={this.onElementChange}
                value={poaPosition}
                isValid={elementValidation[ASI.POSITION].isValid}
                errorMessage={elementValidation[ASI.POSITION].errorMessage}
                isSubmitClicked={isSubmitClicked}
                disabled={occupationNA.includes(poaOccupation)}
              />

              <FormElementContainer>
                <Label label={intl.formatMessage({ id: 'asi.mobile' })} />
                <FormElementContainer isMultpleElements>
                  <CountryCodeDropdown
                    value={poaMobileCC?.isoCode || poaMobileCC}
                    onChange={code => this.onHandleCountryChange(ASI.COUNTRY_CODE_MOBILE, code)
                    }
                  />
                  <Input
                    // label={intl.formatMessage({ id: 'asi.mobile' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.mobile' }).toLowerCase()}`}
                    name={ASI.MOBILE}
                    onInputChange={this.onElementChange}
                    value={poaMobile}
                    isValid={elementValidation[ASI.MOBILE].isValid}
                    errorMessage={elementValidation[ASI.MOBILE].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>
              </FormElementContainer>

              <FormElementContainer>
                <Label label={intl.formatMessage({ id: 'asi.homeNumber' })} />
                <FormElementContainer isMultpleElements>
                  <CountryCodeDropdown
                    value={poaHomeNumberCC?.isoCode || poaHomeNumberCC}
                    onChange={code => this.onHandleCountryChange(
                        ASI.COUNTRY_CODE_HOME_NUMBER,
                        code,
                      )
                    }
                  />
                  <Input
                    // label={intl.formatMessage({ id: 'asi.mobile' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.homeNumber' }).toLowerCase()}`}
                    name={ASI.HOME_NUMBER}
                    onInputChange={this.onElementChange}
                    value={poaHomeNumber}
                    // isValid={elementValidation[ASI.HOME_NUMBER].isValid}
                    // errorMessage={elementValidation[ASI.HOME_NUMBER].errorMessage}
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>
              </FormElementContainer>
              <br />
              <Input
                label={intl.formatMessage({ id: 'asi.employer' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.employer' }).toLowerCase()}`}
                name={ASI.EMPLOYER_BUSINESS_NAME}
                onInputChange={this.onElementChange}
                value={poaEmployerBusinessName}
                isValid={elementValidation[ASI.EMPLOYER_BUSINESS_NAME].isValid}
                errorMessage={
                  elementValidation[ASI.EMPLOYER_BUSINESS_NAME].errorMessage
                }
                isSubmitClicked={isSubmitClicked}
                disabled={occupationNA.includes(poaOccupation)}
              />

              <Input
                label={intl.formatMessage({ id: 'asi.relationshipWithClient' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'asi.relationshipWithClient' }).toLowerCase()}`}
                name={ASI.RELATIONSHIP_WITH_CLIENT}
                onInputChange={this.onElementChange}
                value={poaRelationshipWithClient}
                isValid={
                  elementValidation[ASI.RELATIONSHIP_WITH_CLIENT].isValid
                }
                errorMessage={
                  elementValidation[ASI.RELATIONSHIP_WITH_CLIENT].errorMessage
                }
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            <FormElementContainer>
              <Label label={intl.formatMessage({ id: 'asi.isAuthorized' })} />
              <Options
                isMultpleElements
                type="radio"
                hasContainer
                name={ASI.IS_AS_US_PERSON}
                optionList={defaultBoolOptions.map(item => ({
                  id: `isUS-${item.id}`,
                  label: item.label,
                }))}
                onCheckMarkChange={this.onElementChange}
                defaultValue={poaIsAsUSPerson}
                isValid={elementValidation[ASI.IS_AS_US_PERSON].isValid}
                errorMessage={
                  elementValidation[ASI.IS_AS_US_PERSON].errorMessage
                }
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>
          </>
        )}
      </PaddedContainer>
    );
  }
}

const mapStateToProps = state => ({
  appLanguage: selectors.getLanguage(state),
  isAuthorityToDeal: selectors.getAsiIsAuthorityToDeal(state),
  isPOAholder: selectors.getAsiIsPOAholder(state),
  poaName: selectors.getAsiName(state),
  poaAddress: selectors.getAsiAddress(state),
  poaEmailAddress: selectors.getAsiEmail(state),
  poaNationality: selectors.getAsiNationality(state),
  poaDateOfBirth: selectors.getFormatedAsiDOB(state),
  poaOccupation: selectors.getAsiOccupation(state),
  poaPosition: selectors.getAsiPosition(state),
  poaMobile: selectors.getAsiMobile(state),
  poaMobileCC: selectors.getAsiMobileCC(state),
  poaHomeNumber: selectors.getAsiHomeNumber(state),
  poaHomeNumberCC: selectors.getAsiHomeNumberCC(state),
  poaEmployerBusinessName: selectors.getAsiEmployer(state),
  poaRelationshipWithClient: selectors.getAsiRelationship(state),
  poaIsAsUSPerson: selectors.getAsiUSperson(state),

  userDOB: selectors.getDateOfBirth(state),
  userAge: selectors.getAge(state),

  formOptions: selectors.getFormOptions(state),

  isSubmitClicked: selectors.getIsFormSubmitted(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateASI: (name, value) => dispatch(personalInformation.updateAsi(name, value)),
  onUpdateIsPoa: val => dispatch(personalInformation.saveIsPoa(val)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AuthorizedSignatoryInformation));
